<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.25 22.17A1.24 1.24 0 018 20.92V19H3.25A1.25 1.25 0 012 17.75V3.25A1.25 1.25 0 013.25 2h17.5A1.25 1.25 0 0122 3.25v14.5A1.25 1.25 0 0120.75 19h-7.61l-3 2.84a1.23 1.23 0 01-.89.33zM4 17h6v2.2l2.36-2.2H20V4H4zM20.75 4z"/></svg>